<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-row>
          <b-col>
            <b-form-group
              class="mb-0"
              label-for="counter_edate"
            >
              <b-form-datepicker
                id="counter_edate"
                v-model="summaryFilterParams.counter_edate"
                v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                locale="tr"
                start-weekday="1"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="auto"
          >
            <b-button
              variant="primary"
              @click="getReport"
            >
              <FeatherIcon icon="FilterIcon" />
              Filtrele
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col
      v-for="(counter,index) in reportData.counters"
      :key="index"
    >
      <statistic-card
        :icon="counter.icon"
        :color="counter.color"
        :toplam="counter.toplam"
        :zekat="counter.zekat"
        :sadaka="counter.sadaka"
        :statistic-title="counter.title"
        :details="counter.details"
      />
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BCard, BFormGroup, BFormDatepicker, BButton,
} from 'bootstrap-vue'
import StatisticCard from '@/views/Admin/Account_activities/Components/Counters/StatisticCard.vue'

export default {
  name: 'Counters',
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormDatepicker,
    BButton,
    StatisticCard,
  },
  props: {
    getReport: {
      type: Function,
      required: true,
    },
  },
  computed: {
    reportData() {
      return this.$store.getters['generalReports/reportData']
    },
    summaryFilterParams() {
      return this.$store.getters['generalReports/summaryFilterParams']
    },
  },
}
</script>
